// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"Slider_Pagination__CAiq7","Overflow":"Slider_Overflow__2Ejer"};